import { Link } from 'react-router';

export function NotFound() {
  return (
    <main className="flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-xl border bg-white p-8 text-center shadow-sm">
        <h1 className="mb-2 text-2xl">Page not found</h1>
        <Link to="/dashboard" className="ff-link text-sm">
          ← Back to the dashboard
        </Link>
      </div>
    </main>
  );
}
